import { format } from 'date-fns';

export const formatByString = (str: string, formatStr = 'yyyy年M月d日') => {
  if (Date.parse(str)) {
    return format(new Date(str), formatStr);
  }
  return '';
};
